"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselDot = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _PhotoCarouselDot = require("./PhotoCarouselDot.styles");
/**
 * Shows an individual pagination dot. Used by `PhotoCarouselDots`.
 *
 * @since 8.66.0
 */
var PhotoCarouselDot = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_PhotoCarouselDot.StyledPhotoCarouselDot, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.PhotoCarouselDot = PhotoCarouselDot;
PhotoCarouselDot.displayName = 'PhotoCarouselDot';